import React from 'react'
import routes from '../config/settings/routes'
import { AboutSiteNavProvider } from '../components/Navigation/AboutSiteNavButton.context'
import ProtectByFeatures from '../components/Security/ProtectByFeatures'
import AboutLayout from '../components/Layouts/AboutLayout'
import BrandLayout from '../components/Layouts/BrandLayout'
import AboutSiteGoalSectionContainer from '../containers/AboutSiteGoalSection/AboutSiteGoalSection.container'
import FooterContainer from '../containers/Footer/Footer.container'
import SearchBuyerPanelContainer from '../containers/SearchBuyerPanel/SearchBuyerPanel.container'
import TopNavbarContainer from '../containers/TopNavbar/TopNavbar.container'
import NotFoundPage from './NotFound'

/**
 * The AboutSiteGoal's page.
 */
const AboutSiteGoal = () => (
  <ProtectByFeatures
    fallback={() => <NotFoundPage />}
    rule={features => features['cl.chilecompra.datos-abiertos/about-page']}
  >
    <BrandLayout footer={<FooterContainer />}>
      <TopNavbarContainer menuActive={routes.about} />
      <SearchBuyerPanelContainer />
      <AboutSiteNavProvider>
        <AboutLayout menuActive={routes.aboutSiteGoal}>
          <AboutSiteGoalSectionContainer />
        </AboutLayout>
      </AboutSiteNavProvider>
    </BrandLayout>
  </ProtectByFeatures>
)

export default AboutSiteGoal
